import type { Slider } from '~/types'

export const homepageSliderData: Slider[] = [
  {
    id: 1,
    title: 'Feed your dog with love',
    subtitle: 'All natural dog food, made farm fresh in Australia.',
    buttonText: 'Shop Natural Dog Food',
    buttonLink: '/shop'
  },
  {
    id: 2,
    title: 'Your dog is unique',
    subtitle: "Our pet nutritionists create a meal plan that's just for your dog.",
    buttonText: 'Book a Consultation',
    buttonLink: '/consultation'
  },
  {
    id: 3,
    title: 'We know dogs',
    subtitle: "We've been making all natural dog food for over 25 years.",
    buttonText: 'Read Our Story',
    buttonLink: '/our-story'
  }
]
